let worker

export const getUploadWorker = () => {
	if (!worker) {
		worker = new Worker("./UploadWorkerInstance", { name: "upload worker", type: "module" })
	}

	return worker
}